import { useRouter } from 'next/router';
import { twJoin } from 'tailwind-merge';

import ToggleBadge from 'molecules/Badge/ToggleBadge';
import Button from 'molecules/Button';
import DropDown from 'molecules/Dropdown';

import useBlogListingStore, { clearBlogFilters, updateBlogFilters } from 'layout/Listing/variants/blog/store';

import blogCategories from 'data/blogTags.json';

import type { FC } from 'react';

interface BlogFiltersProps {}

const BlogFilters: FC<BlogFiltersProps> = () => {
  const filter = useBlogListingStore(state => state.filters);
  const router = useRouter();

  return (
    <>
      {blogCategories && (
        <div className="col-span-full hidden flex-wrap items-center gap-4 lg:flex">
          <ToggleBadge
            label="All"
            defaultPressed
            pressed={filter === 'All'}
            onPressedChange={e => e && updateBlogFilters(router, 'All')}
          />
          {blogCategories.map(category => (
            <ToggleBadge
              key={category}
              label={category}
              pressed={filter === category}
              onPressedChange={(pressed: boolean) => pressed && updateBlogFilters(router, category)}
            />
          ))}
          <Button
            className={twJoin(filter === 'All' && 'hidden')}
            hierarchy="linkGray"
            startIcon="x-circle"
            label="Clear Filters"
            onClick={clearBlogFilters}
          />
        </div>
      )}
      <div className="flex items-center lg:hidden">
        <Button
          className={twJoin(filter === 'All' && 'hidden')}
          hierarchy="linkGray"
          startIcon="x-circle"
          label="Clear Filters"
          onClick={clearBlogFilters}
        />
      </div>
      <div className="lg:hidden">
        <DropDown
          placeholder="Filter by category"
          options={blogCategories}
          value={[filter]}
          onChange={e => updateBlogFilters(router, e as string)}
        />
      </div>
    </>
  );
};

export default BlogFilters;
